import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { getAllTradesListSuccess, getAllTradesListFailure } from "../../Action/transaction/allTradesAction";
import { ALL_TRADES_LIST } from "../../Action/actionTypes";
import { notifyError } from "../../../Utils/Helper";
import { GET_DEAL_PARAMS } from "../../../Utils/Constants";

function* allTradesListRequest(action) {
  try {
    const { accountno, sdate, edate, per_page, page, filter, search } = action?.payload?.payload || {};
    
    // Prepare query parameters
    const queryParams = new URLSearchParams({
      type: GET_DEAL_PARAMS
    }).toString();
    
    const { data } = yield API.post(`/all-trade-orders?${queryParams}`, {
      accountno,
      sdate,
      edate,
      per_page,
      page,
      filter, // Add filter to the API request
      ...(search && { search }) // Add search term to the API request if it exists
    });

    if (data?.meta?.code === 200) {
      yield put(getAllTradesListSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(getAllTradesListFailure());
      notifyError("Failed to fetch trade orders.");
    }
  } catch (error) {
    yield put(getAllTradesListFailure());
    notifyError("Failed to fetch trade orders.");
  }
}

export function* watchAllTradesListAPI() {
  yield takeEvery(ALL_TRADES_LIST, allTradesListRequest);
}

export default function* rootSaga() {
  yield all([watchAllTradesListAPI()]);
}